import axios from 'axios'

// 创建axios实例
const service = axios.create({
  // 基础URL，根据环境变量配置
  baseURL: import.meta.env.VITE_BASE_API || '/api',
  // 请求超时时间
  timeout: 10000,
  // 默认请求头
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 获取token
    const token = localStorage.getItem('token') || sessionStorage.getItem('token')
    // 如果有token，添加到请求头
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    // 可以在这里添加其他请求参数或处理
    return config
  },
  error => {
    // 请求错误处理
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 只返回数据部分
    const res = response.data
    
    // 这里可以根据后端返回的状态码进行统一处理
    // 例如：
    if (res.code && res.code !== 200) {
      // 处理错误
      console.error('响应错误:', res.msg || '请求失败')
      // 可以添加错误提示，如使用element-plus的ElMessage
      // ElMessage.error(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    } else {
      return res
    }
  },
  error => {
    // 响应错误处理
    console.error('响应错误:', error)
    
    // 统一错误提示
    let message = '网络错误，请稍后重试'
    if (error.response) {
      // 服务器返回错误
      const { status, data } = error.response
      switch (status) {
        case 401:
          message = '登录过期，请重新登录'
          // 可以在这里处理登录过期逻辑，如跳转到登录页
          break
        case 403:
          message = '没有权限访问该资源'
          break
        case 404:
          message = '请求的资源不存在'
          break
        case 500:
          message = '服务器内部错误'
          break
        default:
          message = data.msg || `请求失败(${status})`
      }
    } else if (error.request) {
      // 请求发出但没有收到响应
      message = '服务器无响应，请稍后重试'
    }
    
    // 可以添加错误提示，如使用element-plus的ElMessage
    // ElMessage.error(message)
    
    return Promise.reject(new Error(message))
  }
)

export default service